const routes = [
    {
        path: "/coop/career-counseling",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
